import "core-js/modules/es.function.name.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-6b88711e"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "IntroVoice"
};
var _hoisted_2 = {
  id: "myAudio"
};
var _hoisted_3 = ["src"];
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    style: {
      "color": "#FFF",
      "text-shadow": "7px -2px 4px rgba(0, 0, 0, 0.25)",
      "font-family": "'Nunito Sans'",
      "font-size": "32px",
      "font-style": "normal",
      "font-weight": "700",
      "text-align": "left",
      "max-width": "392px",
      "margin": "0 auto",
      "margin-top": "19px",
      "width": "90vw",
      "line-height": "27px"
    }
  }, " Perfect! ", -1);
});
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    style: {
      "color": "#000",
      "text-align": "left",
      "text-shadow": "0px 4px 4px rgba(0, 0, 0, 0.25)",
      "font-family": "'Nunito Sans'",
      "font-size": "24px",
      "font-style": "normal",
      "font-weight": "300",
      "line-height": "normal",
      "max-width": "392px",
      "margin": "0 auto",
      "margin-top": "6px",
      "width": "90vw"
    }
  }, " Now, let's customize your AIVitar ", -1);
});
var _hoisted_6 = {
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "width": "100vw",
    "max-width": "400px",
    "padding": "10px",
    "gap": "15px",
    "margin": "0 auto"
  }
};
var _hoisted_7 = {
  style: {
    "flex": "1"
  }
};
var _hoisted_8 = {
  "class": "avatar__holder"
};
var _hoisted_9 = ["src"];
var _hoisted_10 = {
  "class": "avatar__name"
};
var _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div style=\"flex:1;\" data-v-6b88711e><div class=\"row\" data-v-6b88711e><div class=\"active-icon\" data-v-6b88711e><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"23\" height=\"30\" viewBox=\"0 0 23 30\" fill=\"none\" data-v-6b88711e><g filter=\"url(#filter0_d_31_723)\" data-v-6b88711e><path d=\"M2.6556 24.3108L13.5893 15.0547C13.7654 14.9055 13.9068 14.7204 14.0038 14.5122C14.1007 14.3039 14.1509 14.0774 14.1509 13.8482C14.1509 13.619 14.1007 13.3925 14.0038 13.1842C13.9068 12.9759 13.7654 12.7909 13.5893 12.6417L2.6556 3.38554C1.61197 2.50217 -6.39271e-05 3.23456 -6.40458e-05 4.59205L-6.56644e-05 23.107C-6.57831e-05 24.4645 1.61197 25.1969 2.6556 24.3108Z\" fill=\"white\" data-v-6b88711e></path></g><defs data-v-6b88711e><filter id=\"filter0_d_31_723\" x=\"-0.00012207\" y=\"0\" width=\"22.151\" height=\"29.6981\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\" data-v-6b88711e><feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\" data-v-6b88711e></feFlood><feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\" data-v-6b88711e></feColorMatrix><feOffset dx=\"4\" dy=\"1\" data-v-6b88711e></feOffset><feGaussianBlur stdDeviation=\"2\" data-v-6b88711e></feGaussianBlur><feComposite in2=\"hardAlpha\" operator=\"out\" data-v-6b88711e></feComposite><feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0\" data-v-6b88711e></feColorMatrix><feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_31_723\" data-v-6b88711e></feBlend><feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_31_723\" result=\"shape\" data-v-6b88711e></feBlend></filter></defs></svg></div> Voice </div><div class=\"row row--upcoming\" data-v-6b88711e>Personality</div><div class=\"row row--upcoming\" data-v-6b88711e>interests</div></div>", 1);
var _hoisted_12 = {
  "class": "content__holder"
};
var _hoisted_13 = {
  "class": "content__title"
};
var _hoisted_14 = {
  "class": "content-row-container"
};
var _hoisted_15 = {
  key: 0
};
var _hoisted_16 = {
  "class": "content-row-label"
};
var _hoisted_17 = ["onClick"];
var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    "class": "content-row-sample-icon"
  }, [/*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [/*#__PURE__*/_createElementVNode("path", {
    d: "M12 2.5C12.3729 2.50002 12.7324 2.63892 13.0084 2.88962C13.2844 3.14032 13.4572 3.48484 13.493 3.856L13.5 4V20C13.4998 20.3852 13.3514 20.7556 13.0856 21.0344C12.8198 21.3132 12.4569 21.479 12.0721 21.4975C11.6873 21.516 11.3102 21.3858 11.0188 21.1338C10.7274 20.8818 10.5442 20.5274 10.507 20.144L10.5 20V4C10.5 3.60218 10.658 3.22064 10.9393 2.93934C11.2206 2.65804 11.6022 2.5 12 2.5ZM8 5.5C8.39782 5.5 8.77936 5.65804 9.06066 5.93934C9.34196 6.22064 9.5 6.60218 9.5 7V17C9.5 17.3978 9.34196 17.7794 9.06066 18.0607C8.77936 18.342 8.39782 18.5 8 18.5C7.60218 18.5 7.22064 18.342 6.93934 18.0607C6.65804 17.7794 6.5 17.3978 6.5 17V7C6.5 6.60218 6.65804 6.22064 6.93934 5.93934C7.22064 5.65804 7.60218 5.5 8 5.5ZM16 5.5C16.3978 5.5 16.7794 5.65804 17.0607 5.93934C17.342 6.22064 17.5 6.60218 17.5 7V17C17.5 17.3978 17.342 17.7794 17.0607 18.0607C16.7794 18.342 16.3978 18.5 16 18.5C15.6022 18.5 15.2206 18.342 14.9393 18.0607C14.658 17.7794 14.5 17.3978 14.5 17V7C14.5 6.60218 14.658 6.22064 14.9393 5.93934C15.2206 5.65804 15.6022 5.5 16 5.5ZM4 8.5C4.39782 8.5 4.77936 8.65804 5.06066 8.93934C5.34196 9.22064 5.5 9.60218 5.5 10V14C5.5 14.3978 5.34196 14.7794 5.06066 15.0607C4.77936 15.342 4.39782 15.5 4 15.5C3.60218 15.5 3.22064 15.342 2.93934 15.0607C2.65804 14.7794 2.5 14.3978 2.5 14V10C2.5 9.60218 2.65804 9.22064 2.93934 8.93934C3.22064 8.65804 3.60218 8.5 4 8.5ZM20 8.5C20.3729 8.50002 20.7324 8.63892 21.0084 8.88962C21.2844 9.14032 21.4572 9.48484 21.493 9.856L21.5 10V14C21.4998 14.3852 21.3514 14.7556 21.0856 15.0344C20.8198 15.3132 20.4569 15.479 20.0721 15.4975C19.6873 15.516 19.3102 15.3858 19.0188 15.1338C18.7274 14.8818 18.5442 14.5274 18.507 14.144L18.5 14V10C18.5 9.60218 18.658 9.22064 18.9393 8.93934C19.2206 8.65804 19.6022 8.5 20 8.5Z",
    fill: "#808080"
  })])], -1);
});
var _hoisted_19 = ["onClick"];
var _hoisted_20 = {
  "class": "pagination"
};
var _hoisted_21 = {
  key: 0
};
var _hoisted_22 = ["onClick"];
var _hoisted_23 = {
  "class": "bottomHolder"
};
var _hoisted_24 = {
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "max-width": "400px",
    "bottom": "0px",
    "position": "sticky",
    "margin": "0px auto"
  }
};
var _hoisted_25 = {
  style: {
    "display": "flex",
    "flex": "0 0 30%"
  }
};
var _hoisted_26 = /*#__PURE__*/_createStaticVNode("<div class=\"backbutton__icon\" data-v-6b88711e><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"23\" height=\"31\" viewBox=\"0 0 23 31\" fill=\"none\" data-v-6b88711e><g filter=\"url(#filter0_d_30_369)\" data-v-6b88711e><path d=\"M12.1557 4.04764L1.222 13.3038C1.04586 13.453 0.904464 13.6381 0.807527 13.8463C0.71059 14.0546 0.6604 14.2811 0.6604 14.5103C0.6604 14.7395 0.71059 14.966 0.807527 15.1743C0.904464 15.3825 1.04586 15.5676 1.222 15.7168L12.1557 24.973C13.1993 25.8563 14.8113 25.1239 14.8113 23.7664V5.25151C14.8113 3.89402 13.1993 3.16163 12.1557 4.04764Z\" fill=\"white\" data-v-6b88711e></path></g><defs data-v-6b88711e><filter id=\"filter0_d_30_369\" x=\"0.6604\" y=\"0.66037\" width=\"22.1509\" height=\"29.6981\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\" data-v-6b88711e><feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\" data-v-6b88711e></feFlood><feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\" data-v-6b88711e></feColorMatrix><feOffset dx=\"4\" dy=\"1\" data-v-6b88711e></feOffset><feGaussianBlur stdDeviation=\"2\" data-v-6b88711e></feGaussianBlur><feComposite in2=\"hardAlpha\" operator=\"out\" data-v-6b88711e></feComposite><feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0\" data-v-6b88711e></feColorMatrix><feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_30_369\" data-v-6b88711e></feBlend><feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_30_369\" result=\"shape\" data-v-6b88711e></feBlend></filter></defs></svg></div><div class=\"button__label\" data-v-6b88711e>Back</div>", 2);
var _hoisted_28 = [_hoisted_26];
var _hoisted_29 = {
  style: {
    "display": "flex",
    "flex": "0 0 70%",
    "justify-content": "flex-end"
  }
};
var _hoisted_30 = {
  "class": "button__label"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("audio", _hoisted_2, [_createElementVNode("source", {
    src: $data.AudioFileToPlay,
    type: "audio/mp3"
  }, null, 8, _hoisted_3), _createTextVNode(" Your system does not support the audio element. ")]), _hoisted_4, _hoisted_5, _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("img", {
    "class": "avatar__image",
    src: _ctx.$store.state.selectedGalleryAvatar.image
  }, null, 8, _hoisted_9)]), _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$store.state.selectedGalleryAvatar.name), 1)]), _hoisted_11]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createTextVNode("Now, Select The Voice You "), _createElementVNode("div", null, "Would Like " + _toDisplayString(_ctx.$store.state.selectedGalleryAvatar.name) + " To Have", 1)]), _createElementVNode("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.actualVoiceList, function (voice, voiceID) {
    return _openBlock(), _createElementBlock("div", {
      "class": "content-row",
      key: voice.label
    }, [voiceID < $data.itemsPerPage * $data.currentPage && voiceID > $data.itemsPerPage * ($data.currentPage - 1) ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("span", _hoisted_16, _toDisplayString(voice.label), 1), _createElementVNode("button", {
      "class": _normalizeClass({
        'content-row-sample': true,
        'content-row-sample--playing': voice.playing
      }),
      onClick: function onClick($event) {
        return $options.playSample(voiceID);
      }
    }, [_hoisted_18, _createTextVNode(" " + _toDisplayString(voice.playing ? 'Playing Sample' : 'Play Sample'), 1)], 10, _hoisted_17), _createElementVNode("button", {
      "class": _normalizeClass({
        'content-row-button': true,
        'content-row-button--selected': voice.selected || _ctx.$store.state.customerSelectedVoice == voice.code
      }),
      onClick: function onClick($event) {
        return $options.selectVoice(voiceID);
      }
    }, _toDisplayString(voice.selected || _ctx.$store.state.customerSelectedVoice == voice.code ? 'Selected' : 'Select'), 11, _hoisted_19)])) : _createCommentVNode("", true)]);
  }), 128))]), _createElementVNode("div", _hoisted_20, [$data.totalPages > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_21, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.totalPages, function (index) {
    return _openBlock(), _createElementBlock("button", {
      key: index,
      "class": _normalizeClass({
        'pagination-button': true,
        'pagination-button--selected': $data.currentPage === index
      }),
      onClick: function onClick($event) {
        return $data.currentPage = index;
      }
    }, _toDisplayString(index), 11, _hoisted_22);
  }), 128))])) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [!this.$store.state.singleIntroSave ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    "class": "button",
    style: {
      "padding-top": "0px"
    },
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $options.backButton();
    })
  }, _hoisted_28)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_29, [_createElementVNode("button", {
    "class": _normalizeClass({
      'button': true,
      'button--secondary': true,
      'button--not-ready': !this.$store.state.customerSelectedVoice || this.$store.state.customerSelectedVoice == ''
    }),
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $options.acceptVoice();
    })
  }, [_createElementVNode("div", _hoisted_30, _toDisplayString(!this.$store.state.customerSelectedVoice || this.$store.state.customerSelectedVoice == '' ? 'Awaiting Selection' : 'Accept Voice Settings'), 1)], 2)])])])]);
}